
import { supabase } from '@/integrations/supabase/client';

export interface ExportResponse {
  success: boolean;
  message?: string;
  error?: string;
}

export async function exportSubscriptions(email: string): Promise<ExportResponse> {
  try {
    const { data, error } = await supabase.functions.invoke('send-subscription-export', {
      body: { email },
    });

    if (error) {
      console.error('Export subscriptions error:', error);
      return {
        success: false,
        error: error.message || 'Failed to export subscriptions'
      };
    }

    return {
      success: true,
      message: 'Subscriptions export has been sent to your email'
    };
  } catch (error) {
    console.error('Export subscriptions exception:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Failed to export subscriptions'
    };
  }
}

export async function exportSubscriptionServices(email: string): Promise<ExportResponse> {
  try {
    const { data, error } = await supabase.functions.invoke('fetch-subscription-services-and-send-email', {
      body: { email },
    });

    if (error) {
      console.error('Export subscription services error:', error);
      return {
        success: false,
        error: error.message || 'Failed to export subscription services'
      };
    }

    return {
      success: true,
      message: 'Subscription services export has been sent to your email'
    };
  } catch (error) {
    console.error('Export subscription services exception:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Failed to export subscription services'
    };
  }
}
